var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wx-img"},[_c('div',{staticClass:"angle"}),_c('div',{staticClass:"angle bottom"}),_c('div',{staticClass:"scan"}),_c('div',{staticClass:"scan-img"},[_c('img',{attrs:{"draggable":"false","src":_vm.login.codeUrl,"alt":""}})])]),_c('div',{staticClass:"wx-tip text-center"},[_vm._v(" 打开微信扫一扫，快速登录/注册 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }